import { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import useCurrentUserProfile from "../../../../hooks/useCurrentUserProfile";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const UniversityDashboard = () => {
  const {profile} = useCurrentUserProfile()
  const {university_name,dean_name,department_name}=useParams()
  const [labs, setLabs] = useState([]);
  const [lab_groups, setLabGroups] = useState([]);
  const [departments, setDepartments] = useState([]);
  
 const [deans, setDeans] = useState([]);
   const fetchDeans = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/university/dean/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        setDeans(res?.data || []);
      } catch (error) {
        console.log("Error while getting profiles", error);
        setDeans([]);
      }
    };
  useEffect(() => {
    fetchDeans();
  }, []);
  // console.log("The lab groups are:",lab_groups)

  const fetchDepartments = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/marketplace/university/department/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );
      setDepartments(res?.data || []);
    } catch (error) {
      console.log("Error while getting profiles", error);
      setDepartments([]);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);
  
  return (
    <div className="min-h-screen">
      {/* Dashboard Card */}
      <div className="">
        <div className="">
          
          {/* Header with Icon */}
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
              <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-gray-900">
                {profile?.name}
              </h1>
              <p className="text-sm text-gray-500 mt-1">
                Welcome to your dashboard. You are managing this laboratory and its activities.
              </p>
            </div>
          </div>

          {/* Info Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {/* Laboratory */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                 <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Deans</p>
                  <p className="text-sm font-medium text-gray-900">{deans?.length} Deans</p>
                </div>
              </div>
            </div>

            {/* Groups */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Departments</p>
                  <p className="text-sm font-medium text-gray-900">{departments?.length} Departments</p>
                </div>
              </div>
            </div>

            {/* Members */}
            <div className="bg-white p-4  rounded-xl border border-gray-200 hover:border-[#0f6abf] transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                <svg
  className="w-4 h-4 text-[#0f6abf]"
  fill="none"
  stroke="currentColor"
  viewBox="0 0 24 24"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5 5.015 5 3 6.567 3 8.5v11c0-1.933 2.015-3.5 4.5-3.5 1.746 0 3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5 18.985 5 21 6.567 21 8.5v11c0-1.933-2.015-3.5-4.5-3.5-1.746 0-3.332.477-4.5 1.253"
  />
</svg>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Courses</p>
                  <p className="text-sm font-medium text-gray-900">0 Courses</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default UniversityDashboard;